import React, { PureComponent } from "react";
import { ICSS, Color, ICSSProps, ColorProps, GlobalColorPalette, Icon } from "@gago/frame";
import { Modal, Carousel } from "antd";
import { PlayerModalBoay } from "./style";
import { Player } from "../../components";

type RProps = {
  /** 回调函数返回组件  */
  onRef?(component: PlayerModal): void;
  /** 传入模态框的数据 */
  url?: string;
} & ICSSProps & ColorProps<GlobalColorPalette>;
interface RState {
  /** 模态框打开状态 */
  modalStatus: boolean;
}
// tslint:disable:jsx-no-lambda jsx-no-multiline-js ter-max-len
/**
 * 物联网播放模态框
 * @author 马俊峰
 * @date 2020-08-04
 * @export
 * @class PlayerModal
 * @extends {PureComponent<RProps, RState>}
 * @implements {ICSS}
 * @implements {Color}
 */
export class PlayerModal extends PureComponent<RProps, RState> implements ICSS, Color {
  /** 走马灯的元素 */
  carousel: Carousel | null = null;
  state: RState = {
    modalStatus: false,
  };
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }
  render() {
    const { style, className, colorPalette } = this.props;
    const { modalStatus } = this.state;
    return(
      <PlayerModalBoay style={style} className={className} colorPalette={colorPalette} id="village_modal">
        <Modal
          title="物联网监控视频"
          visible={modalStatus}
          getContainer={() => document.getElementById("village_modal") as HTMLElement}
          closable={false}
          footer={false}
          destroyOnClose
        >
          <div className="rombody">
            <span className="close-modal" onClick={this.closeModal}>
              <Icon className="close-icon">close-circle</Icon>
            </span>
            <div className="carousel-box">
              <Player url="http://zengcheng.fm-dev.gagogroup.cn:31090/api/v1/device/video" />
              {/* <Player url="http://cyberplayer.bcelive.com/videoworks/mda-kbuhu4wqdi08dwix/cyberplayer/flv/cyberplayer-demo.flv" /> */}
              {/* <Player url="http://cyberplayer.bcelive.com/videoworks/mda-kbuhu4wqdi08dwix/cyberplayer/mp4/cyberplayer-demo.mp4" /> */}
            </div>
          </div>
        </Modal>
      </PlayerModalBoay>
    );
  }
  /** 打开模态框事件 */
  openModal = () => {
    this.setState({ modalStatus: true });
  }
  /** 关闭模态框事件 */
  closeModal = () => {
    this.setState({ modalStatus: false });
  }
}
